<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <template>
    <v-layout row wrap>
      <v-form v-model="valid">
        <v-layout row wrap justify-center>
          <v-flex xs6 md2>
            <v-select
              :items="filtros"
              item-text="title"
              label="Filtros"
              item-value="value"
              v-model="filtro"
            >
            </v-select>
          </v-flex>
          <v-flex xs6 md2 shrink>
            <v-select
              :items="frentistas"
              label="Frentista"
              item-value="id_frentista"
              v-model="opcoes.id_frentista"
              clearable
            >
              <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs5 md2 shrink>
            <v-text-field
              placeholder="CPF"
              mask="###.###.###-##"
              v-model="opcoes.masked_cpf"
              return-masked-value
              :rules="[rules.cpf]"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 md2 shrink>
            <v-select
              :items="redes"
              label="Redes"
              item-value="id_rede"
              v-model="id_rede"
              clearable
            >
              <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo || (data.item.matriz && data.item.matriz.url_logo)" :src="data.item.url_logo || data.item.matriz.url_logo" alt="logo">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo || (data.item.matriz && data.item.matriz.url_logo)" :src="data.item.url_logo || data.item.matriz.url_logo" alt="logo">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs4 md1>
            <v-select
              :items="options"
              item-text="title"
              item-value="value"
              v-model="selectOpcoes"
            >
            </v-select>
          </v-flex>
          <v-flex xs4 :md3="opcoes.custom" :md2="!opcoes.custom">
            <v-menu
              ref="menuDataInicial"
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-if="opcoes.custom"
                  v-model="opcoes.intervalo_relatorio"
                  label="Dias"
                  multiple
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else-if="opcoes.dia"
                  v-model="opcoes.data_relatorio"
                  label="Dia"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="date = parseDate(opcoes.data_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else
                  v-model="opcoes.mes_relatorio"
                  label="Mes"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="month = parseDate(opcoes.mes_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
              </template>
              <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs5 md2 shrink>
            <v-select
              :items="[
                {text: 'Pós-paga', value: 'pospago'},
                {text: 'Pré-paga', value: 'prepago'},
                {text: 'Presencial', value: 'presencial'}
              ]"
              item-text="text"
              label="Tipo de proposta"
              item-value="value"
              v-model="tipo_proposta"
              clearable
            />
          </v-flex>
          <v-flex xs5 md2 shrink>
            <v-select
              :items="propostas"
              item-text="identificacao"
              label="Número da proposta"
              item-value="id"
              v-model="proposta"
              clearable
            />
          </v-flex>
          <v-flex xs5 md2 shrink>
            <v-select
              :items="postaDaRede"
              label="Posto da Rede"
              item-value="cnpj"
              v-model="opcoes.posto_cnpj"
              clearable
            >
              <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo" :src="data.item.url_logo" alt="logo">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-if="data.item" v-text="`${data.item.nome_fantasia}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo" :src="data.item.url_logo" alt="logo">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome_fantasia}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs6 md3 shrink class="mr-4">
            <v-select
              :items="empresas"
              label="Empresa"
              item-value="cnpj"
              v-model="opcoes.empresa_cnpj"
              clearable
            >
              <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo" :src="data.item.url_logo" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome_fantasia}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_logo" :src="data.item.url_logo" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome_fantasia}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de vouchers da empresa</h1>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!vouchersEmpresa || !vouchersEmpresa.length"
          :loading="loading"
          :items="vouchersEmpresa"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.codigo"><strong>{{props.item.numero}}</strong></td>
              <td class="text-xs-left px-3" style="width: auto" v-if="headersVisible.funcionario">
                <template v-if="props.item.funcionario">
                  {{props.item.funcionario && props.item.funcionario.pessoa ? `${props.item.funcionario.pessoa.nome} ${props.item.funcionario.pessoa.sobrenome}`: 'Não informado' | truncate(30) }}
                  <div><strong>{{ props.item.funcionario && props.item.funcionario.pessoa ? props.item.funcionario.pessoa.cpf : 'Não informado'}}</strong></div>
                </template>
              </td>
              <td class="text-xs-left px-3" style="width: auto" v-if="headersVisible.empresa">
                <template v-if="props.item.empresa_beneficiada">
                  {{`${props.item.empresa_beneficiada.nome_fantasia}` | truncate(30) }}
                  <div><strong>{{props.item.empresa_beneficiada.cnpj}}</strong></div>
                </template>
              </td>
              <td class="text-xs-left" v-if="headersVisible.data_gerado">{{ props.item.data_gerado.split('-').reverse().join('/') }}</td>
              <td class="text-xs-left" v-if="headersVisible.data_uso">
                <template v-if="props.item.data_inativado">
                  {{ props.item.data_inativado.split('-').reverse().join('/') }}
                </template>
              </td>
              <td class="text-xs-left" v-if="headersVisible.valor_compra">{{props.item.valor | currency({ fractionCount: 2 }) }}</td>
              <td class="text-xs-left" v-if="headersVisible.data_compra">{{ props.item.compra.data_compra.split('-').reverse().join('/') }}</td>
              <td class="text-xs-right" v-if="headersVisible.valor"><strong>{{ props.item.valor | currency({ fractionCount: 2 }) }}</strong></td>
              <td class="text-xs-center px-0 hide-print" style="width: 0" v-if="headersVisible.status">
                <v-tooltip v-if="props.item.disponivel" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">access_alarms</v-icon>
                  </template>
                  <span>Aguardando abastecimento </span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">done_all</v-icon>
                  </template>
                  <span>Abastecido</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left px-3" v-if="headersVisible.codigo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.codigo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Código
              </th>
              <th class="text-xs-left px-3" v-if="headersVisible.funcionario">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.funcionario = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Funcionário
              </th>
              <th class="text-xs-left px-3" v-if="headersVisible.empresa">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.empresa = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Empresa
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_gerado">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_gerado = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Gerado em
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_uso">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_uso = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Uso em
              </th>
              <th class="text-xs-left" v-if="headersVisible.valor_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor da Compra
              </th>
              <th class="text-xs-left" v-if="headersVisible.data_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data da Compra
              </th>
              <th class="text-xs-right" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.status">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.status = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="vouchersEmpresa && vouchersEmpresa.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_vouchers | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    </template>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      valid: false,
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: null,
      vouchersEmpresa: [],
      postaDaRede: [],
      empresas: [],
      total_relatorio_vouchers: 0,
      id_rede: null,
      dates: [],
      tipo_proposta: null,
      filtroCPF: '',
      filtro: 'todos',
      filtros: [
        {
          title: 'Todos os vouchers',
          value: 'todos'
        },
        {
          title: 'Vouchers consumidos',
          value: 'recebidos'
        }
      ],
      headersVisible: {
        valor: true,
        codigo: true,
        funcionario: true,
        empresa: true,
        data_gerado: true,
        data_uso: true,
        valor_compra: false,
        data_compra: false,
        status: true
      },
      today: null,
      selectOpcoes: 'dia',
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      proposta: undefined,
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        recebidos: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: [],
        id_frentista: null,
        masked_cpf: null,
        id_rede: null,
        empresa_cnpj: null,
        posto_cnpj: null
      },
      rules: {
        cpf: value => {
          const pattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
          return !value || pattern.test(value) || 'CPF inválido.'
        }
      },
      pagination: {
        page: 1,
        rowsPerPage: 20
      },
      totalItens: 0
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    },
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    propostas () {
      return this.$store.getters.propostas
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    redes () {
      return this.$store.getters.redes
    },
    filtro_proposta () {
      return {
        modelo_faturamento: this.tipo_proposta,
        empresa: this.opcoes.empresa_cnpj
      }
    },
    tempOpcoes () {
      let tempOpcoes = {
        run: true
      }
      if (this.tipo_proposta !== null && this.tipo_proposta !== undefined) {
        tempOpcoes.proposta__modelo_faturamento = this.tipo_proposta
      }
      if (this.proposta) tempOpcoes.proposta = this.proposta
      this.opcoes.id_frentista && (tempOpcoes['frentista__id_frentista'] = this.opcoes.id_frentista)
      this.opcoes.empresa_cnpj && (tempOpcoes['empresa_beneficiada'] = this.opcoes.empresa_cnpj)

      if (this.opcoes.id_rede) {
        this.opcoes.id_rede && (tempOpcoes['rede'] = this.opcoes.id_rede)
        this.opcoes.posto_cnpj && (tempOpcoes['posto__cnpj'] = this.opcoes.posto_cnpj)
      } else {
        tempOpcoes['posto__cnpj'] = this.posto.cnpj
      }

      // Vai validar o formato do CPF ou perquisar com autocomplementação
      this.valid && this.opcoes.masked_cpf && this.opcoes.masked_cpf !== '' && (tempOpcoes['usuario_utilizador__cpf'] = this.opcoes.masked_cpf.replace(/[^\d]+/g, ''))

      if (this.filtro === 'recebidos') {
        tempOpcoes['disponivel'] = false
        if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
          tempOpcoes['data_inativado__gte'] = this.opcoes.intervalo_relatorio[0]
          tempOpcoes['data_inativado__lte'] = this.opcoes.intervalo_relatorio[1]
        } else if (this.opcoes.dia && this.date) {
          tempOpcoes['data_inativado'] = this.date.split('-').reverse().join('/')
        } else if (this.opcoes.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          tempOpcoes['data_inativado__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          tempOpcoes['data_inativado__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        } else {
          tempOpcoes['run'] = false
        }
      } else {
        if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
          tempOpcoes['data_gerado__gte'] = this.opcoes.intervalo_relatorio[0]
          tempOpcoes['data_gerado__lte'] = this.opcoes.intervalo_relatorio[1]
        } else if (this.opcoes.dia && this.date) {
          tempOpcoes['data_gerado'] = this.date.split('-').reverse().join('/')
        } else if (this.opcoes.mes && this.month) {
          const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
          const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

          tempOpcoes['voucher__data_gerado__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
          tempOpcoes['data_gerado__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        } else {
          tempOpcoes['run'] = false
        }
      }

      return tempOpcoes
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.posto) this.carregarRelatorio(false)
      },
      deep: true
    },
    id_rede (val) {
      this.opcoes.id_rede = val
      if (val !== null || val !== undefined) {
        val !== undefined && (this.$store.dispatch('postosDaRede', val).then(value => {
          this.postaDaRede = value
        }))
        this.$store.dispatch('empresaComProposta', {
          cnpjPosto: this.posto.cnpj,
          id_rede: val
        }).then(value => {
          this.empresas = value
        })
      }
    },
    filtro_proposta () {
      this.carregarPropostas()
    },
    posto (val) {
      if (val) {
        this.$store.dispatch('listarFrentistas')
        this.$store.dispatch('pegarRedes')
        this.carregarPropostas()
        this.carregarEmpresas()
      }
    },
    filtro (val) {
      this.opcoes.recebidos = false
      if (val === 'recebidos') {
        this.opcoes.recebidos = true
      }
    },
    filtroCPF (val) {
      this.$store.dispatch('buscarVouchersCPF', val)
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
      } else if (val === 'custom') {
        this.opcoes.custom = true
      } else if (val === 'mes') {
        this.opcoes.mes = true
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) {
      this.$store.dispatch('listarFrentistas')
      this.carregarPropostas()
      this.carregarEmpresas()
    }
  },
  methods: {
    print () {
      window.print()
    },
    carregarEmpresas () {
      this.$store.dispatch('empresaComProposta', {
        cnpjPosto: this.posto.cnpj
      }).then(value => {
        this.empresas = value
      })
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio (zerarPaginacao) {
      if (zerarPaginacao) this.pagination.page = 1
      this.$store.dispatch('relatorioVouchersEmpresa', { filtro: this.tempOpcoes, pagination: this.pagination }).then(relatorio => {
        this.vouchersEmpresa = relatorio.results.vouchers
        this.total_relatorio_vouchers = relatorio.results.valor_total
        this.totalItens = relatorio.count
      })
    },
    carregarPropostas () {
      this.$store.dispatch('buscarPropostasDoPosto', this.filtro_proposta)
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    }
  }
}
</script>
